import { errors } from '../content'

export default {
  customerEmailError: {
    message: errors.invalidCustomerEmail
  }
}
